import "./LogoutButton.css";
import { useAuth } from "core/auth/useAuth";
import { t } from "i18next";
import Button from "shared/UI/Buttons/Button";
import { useNotifyModalContext } from "shared/core/state/NotifyModalContext/NotifyModalContext";

export const LogoutButton = () => {
  const auth = useAuth();
  const { modalNotify } = useNotifyModalContext();

  function logout() {
    auth.signoutRedirect().catch(() => {
      modalNotify("error", t("userProfile.logoutErrMsg"));
    });
  }

  return <Button variant="text" text={t("userProfile.logout")} onClick={logout} />;
};
